import { lazy, type ComponentType } from 'react';
import type { ScreenDef } from '@/lib/types';
import { BelgeScreen } from '../belge/BelgeScreen';
import { SifreDegistir, Hakkinda, Tema, IslemCalistir } from './Simple';
import { KayitFormu } from './KayitFormu';
import { HtmlOnizleme } from './HtmlOnizleme';

export type CustomScreen = ComponentType<{ screen: ScreenDef } & Record<string, any>>;

// büyük özel ekranlar ayrı paketlerde yüklenir (ilk açılış hızı)
const Fatura = lazy(() => import('./Fatura').then((m) => ({ default: m.Fatura as CustomScreen })));
const CariFis = lazy(() => import('./CariFis').then((m) => ({ default: m.CariFis as CustomScreen })));
const CariHareketListesi = lazy(() => import('./CariHareketListesi').then((m) => ({ default: m.CariHareketListesi as CustomScreen })));
const Yetkilendirme = lazy(() => import('./Yetkilendirme').then((m) => ({ default: m.Yetkilendirme as CustomScreen })));
const TekKayitFormu = lazy(() => import('./TekKayitFormu').then((m) => ({ default: m.TekKayitFormu as CustomScreen })));
const SorguListesi = lazy(() => import('./SorguListesi').then((m) => ({ default: m.SorguListesi as CustomScreen })));
const AktifKullanicilar = lazy(() => import('./AktifKullanicilar').then((m) => ({ default: m.AktifKullanicilar as CustomScreen })));
const Ajanda = lazy(() => import('./Ajanda').then((m) => ({ default: m.Ajanda as CustomScreen })));
const MetadataYonetimi = lazy(() => import('./MetadataYonetimi').then((m) => ({ default: m.MetadataYonetimi as CustomScreen })));
const Pivot = lazy(() => import('./Pivot').then((m) => ({ default: m.Pivot as CustomScreen })));
const RaporHazirlama = lazy(() => import('./RaporHazirlama').then((m) => ({ default: m.RaporHazirlama as CustomScreen })));
const Yedekleme = lazy(() => import('./Yedekleme').then((m) => ({ default: m.Yedekleme as CustomScreen })));
const CariFiyat = lazy(() => import('./CariFiyat').then((m) => ({ default: m.CariFiyat as CustomScreen })));
const TezgahIskonto = lazy(() => import('./TezgahIskonto').then((m) => ({ default: m.TezgahIskonto as CustomScreen })));
const Ekstre = lazy(() => import('./Ekstre').then((m) => ({ default: m.Ekstre as CustomScreen })));
const CekSenetFormu = lazy(() => import('./CekSenetFormu').then((m) => ({ default: m.CekSenetFormu as CustomScreen })));
const SayimFisi = lazy(() => import('./SayimFisi').then((m) => ({ default: m.SayimFisi as CustomScreen })));
const SirketTanimlari = lazy(() => import('./SirketTanimlari').then((m) => ({ default: m.SirketTanimlari as CustomScreen })));
const DemoKayitlari = lazy(() => import('./DemoKayitlari').then((m) => ({ default: m.DemoKayitlari as CustomScreen })));

/**
 * Web_Screen.AYAR.bilesen → React bileşeni.
 * Metadata ile çalışmayan (Delphi'de özel kodlanmış) ekranlar burada kayıtlıdır.
 */
export const customScreens: Record<string, CustomScreen> = {
  DizaynBelge: BelgeScreen as CustomScreen,
  KayitFormu: KayitFormu as CustomScreen,
  Fatura,
  HtmlOnizleme: HtmlOnizleme as unknown as CustomScreen,
  CariFis,
  CariHareketListesi,
  Yetkilendirme,
  TekKayitFormu,
  SorguListesi,
  AktifKullanicilar,
  Ajanda,
  MetadataYonetimi,
  Pivot,
  RaporHazirlama,
  Yedekleme,
  SirketTanimlari,
  DemoKayitlari,
  CariFiyat,
  TezgahIskonto,
  SayimFisi,
  CekSenetFormu,
  Ekstre,
  SifreDegistir,
  Hakkinda,
  Tema,
  IslemCalistir,
};

export function registerScreens(map: Record<string, CustomScreen>) {
  Object.assign(customScreens, map);
}

/** Liste ekranından açılacak kayıt formu (Web_Screen.AYAR.kayitFormu) */
export function recordFormFor(screen: ScreenDef): { component: string; title: string; idField?: string; titleField?: string } | null {
  const k = screen.settings?.kayitFormu;
  if (!k) return null;
  if (typeof k === 'object' && k.tur === 'belge') return { component: 'DizaynBelge', title: screen.title, idField: k.idAlan ?? 'ID' };
  if (typeof k === 'object' && k.bilesen === 'KayitFormu') return { component: 'KayitFormu', title: k.baslik ?? screen.title, idField: k.anahtar ?? 'ID', titleField: k.baslikAlan };
  if (typeof k === 'string' && customScreens[k]) return { component: k, title: screen.title, idField: 'ID' };
  if (typeof k === 'object' && k.bilesen && customScreens[k.bilesen]) return { component: k.bilesen, title: k.baslik ?? screen.title, idField: k.idAlan ?? 'ID', titleField: k.baslikAlan };
  return null;
}
